import { organisationRolePermissions } from '@infuse/api/iam/organisation';
import { permissionPermissions } from '@infuse/api/iam/permission';
import { rolePermissions } from '@infuse/api/iam/role';
import { tenantRolePermissions } from '@infuse/api/iam/tenant';
import { RoleDetailSlideIn, RolePermissionsTab, RolesPage } from '@infuse/iam/role/pages';

import { InfusePageView } from '@infuse/ui/layouts';
import { AppRouter } from '@infuse/ui/router';
import { Plugin } from 'vue';

export const RoleFeaturePlugin: Plugin = {
  install() {
    AppRouter.addRoute('main', {
      path: '/role',
      component: InfusePageView,
      meta: {
        name: 'nav.roles',
        icon: 'role',
        group: 'nav.nav-group.iam',
        permissionIds: [rolePermissions.SEARCH, organisationRolePermissions.SEARCH, tenantRolePermissions.SEARCH]
      },
      children: [
        {
          path: '',
          name: 'role',
          component: RolesPage
        },
        {
          path: ':id',
          components: {
            default: RolesPage,
            slideIn: RoleDetailSlideIn
          },
          children: [
            {
              path: '',
              redirect: {
                name: 'role.permissions'
              }
            },
            {
              path: 'permissions',
              name: 'role.permissions',
              component: RolePermissionsTab,
              meta: {
                type: 'tab',
                label: 'tabs.common.permissions',
                permissionIds: [
                  rolePermissions.GET,
                  rolePermissions.SEARCH_PERMISSIONS,
                  permissionPermissions.SEARCH,
                  organisationRolePermissions.SEARCH,
                  tenantRolePermissions.SEARCH,
                  organisationRolePermissions.SEARCH_PERMISSIONS,
                  tenantRolePermissions.SEARCH_PERMISSIONS
                ],
                disablePermissionRouteGuard: true
              }
            }
          ]
        }
      ]
    });
  }
};
